
import View from '../View'
import Text from '../Text'

export default props => <View>This is an awesome site</View>

